import React from 'react';
import Snowfall from './Snowfall';

const ConnectionError = ({
  type,
  loading,
  onRetry,
  theme,
  contentType = 'general',
  message,
  isNewYearMode = false,
}) => {
  const configs = {
    schedule: {
      'no-internet': { icon: 'calendar-outline', title: 'Расписание недоступно', description: 'Для загрузки расписания необходимо подключение к интернету' },
      'load-error': { icon: 'warning-outline', title: 'Ошибка загрузки расписания', description: 'Не удалось загрузить расписание. Проверьте подключение и попробуйте снова' },
    },
    news: {
      'no-internet': { icon: 'newspaper-outline', title: 'Новости недоступны', description: 'Для загрузки новостей необходимо подключение к интернету' },
      'load-error': { icon: 'warning-outline', title: 'Ошибка загрузки новостей', description: 'Не удалось загрузить новости. Проверьте подключение и попробуйте снова' },
    },
    general: {
      'no-internet': { icon: 'cloud-offline-outline', title: 'Нет подключения к интернету', description: 'Для загрузки данных необходимо подключение к интернету' },
      'load-error': { icon: 'warning-outline', title: 'Ошибка загрузки', description: 'Не удалось загрузить данные. Проверьте подключение и попробуйте снова' },
      'default': { icon: 'refresh-outline', title: 'Ошибка', description: 'Произошла непредвиденная ошибка' },
    },
  };

  const config = configs[contentType]?.[type] || configs.general[type] || configs.general.default;

  if (loading) {
    return (
      <div className="connection-error">
        {isNewYearMode && <Snowfall theme={theme} intensity={0.5} />}
        <div className="connection-error__card">
          <div className="spinner" style={{ width: 32, height: 32 }}></div>
          <p className="connection-error__title" style={{ marginTop: 16 }}>Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="connection-error">
      {isNewYearMode && <Snowfall theme={theme} intensity={0.5} />}
      <div className="connection-error__card">
        <ion-icon name={config.icon} class="connection-error__icon"></ion-icon>
        <h2 className="connection-error__title">{config.title}</h2>
        <p className="connection-error__desc">{message || config.description}</p>
        {onRetry && (
          <button className="btn btn--primary btn--full" onClick={onRetry}>
            <ion-icon name="refresh" style={{ fontSize: 20 }}></ion-icon>
            Попробовать снова
          </button>
        )}
      </div>
    </div>
  );
};

export default ConnectionError;
